import ScheduleManageApp from "./ScheduleManageApp.vue";
import { vueAppWithPinia } from "../../Common/vueApp";
import { default as localStorage } from "../../Common/store";
import { default as sessionStorage } from "../../Common/sessionStore";

const DEFAULT_CONFLICTS_THRESHOLD = 1800;

export function saveVisibleMatsToLocalStorage(eventId: number, visibleMats: Record<number, boolean>) {
    localStorage.set(`event_${eventId}_schedule_visible_mats`, JSON.stringify(visibleMats));
}

export function loadVisibleMatsFromLocalStorage(eventId: number) {
    const visibleMats = localStorage.get(`event_${eventId}_schedule_visible_mats`);

    if (!visibleMats) {
        return null;
    }

    return JSON.parse(visibleMats);
}

export function saveConflictsThresholdToLocalStorage(eventId: number, value: number) {
    localStorage.setInt("schedule_conflicts_threshold_" + eventId, value);
}

export function getConflictsThresholdFromLocalStorage(eventId: number) {
    const fromLocalStorage = localStorage.getInt("schedule_conflicts_threshold_" + eventId, null);

    if (fromLocalStorage === null) {
        return DEFAULT_CONFLICTS_THRESHOLD;
    }

    return fromLocalStorage;
}

export function saveScheduleMatsMultiRowModeToLocalStorage(eventId: number, multiRowEnabled: boolean) {
    localStorage.set("manage_schedule_multi_row_mode_" + eventId, multiRowEnabled);
}

export function getScheduleMatsMultiRowModeFromLocalStorage(eventId: number) {
    return localStorage.get("manage_schedule_multi_row_mode_" + eventId) === "true";
}

export function saveEditModeToSessionStorage(eventId: number, editModeEnabled: boolean) {
    sessionStorage.setBoolean("schedule_edit_mode_" + eventId, editModeEnabled);
}

export function isMobileViewport() {
    return window.matchMedia("(max-width: 1023px)").matches;
}

/**
 * An explicit choice made in this session wins; otherwise edit mode is on for desktop and off (read-only) for mobile.
 */
export function getEditModeFromSessionStorage(eventId: number) {
    const stored = sessionStorage.get("schedule_edit_mode_" + eventId);

    return stored === null ? !isMobileViewport() : stored === "true";
}

export default vueAppWithPinia(ScheduleManageApp);
